import { Component, Input } from '@angular/core'
import { UserContextService } from '@core/service/user-context.service'
import { SITUACOES_MATRICULA_ATIVA_IDS, SITUACOES_MATRICULA_DESATUALIZADA } from '@shared/models'
import { ResidenteMatriculadoModel, SituacaoMatriculaDomainModel } from '@shared/models/backend'
import { AccentService } from '@shared/services/accent.service'
import moment from 'moment'

@Component({
  selector: 'app-residente-details',
  templateUrl: './residente-details.component.html',
})
export class ResidenteDetailsComponent {
  @Input()
  residenteMatriculado: ResidenteMatriculadoModel

  @Input()
  isPeriodoInscricao: boolean

  constructor(private accentService: AccentService, private userContext: UserContextService) {}

  getSituacaoResidenteAccent(situacao: SituacaoMatriculaDomainModel) {
    return this.accentService.getSituacaoMatriculaAccent(situacao)
  }

  canShowAnoResidencia() {
    return (
      SITUACOES_MATRICULA_ATIVA_IDS.includes(this.residenteMatriculado?.situacaoMatricula?.id) &&
      this.residenteMatriculado?.anoResidencia
    )
  }

  canShowTagAguardandoInicio() {
    return this.residenteMatriculado?.recemMatriculado && this.isPeriodoInscricao
  }

  isSituacaoResidenteDesatualizada() {
    return (
      this.residenteMatriculado?.situacaoResidente &&
      SITUACOES_MATRICULA_DESATUALIZADA.includes(this.residenteMatriculado.situacaoMatricula.id) &&
      moment(this.residenteMatriculado.situacaoResidente.dataTermino) < moment().startOf('day')
    )
  }

  get isResidente() {
    return this.userContext.isResidente()
  }
}
